/*
 * @Description:
 * @Author:  Teemo Ding
 * @Date: 2021-04-14 15:10:57
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-04-29 17:10:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductContent/index.tsx
 */

import React from 'react';

import { ModuleCart } from '@/src/constrains';
import { EnumModuleType } from '@/src/types/common/module';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Skeleton } from 'src/components/Antd';
import { useSalesChannelProductLinkSet } from 'src/components/LinkModule/hooks';
import ContentGroup from 'src/constrains/DraggableModules/ContentGroup';
import { useSalesChannelType } from 'src/constrains/SalesChannelHOC/useSalesChannel';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/BasicPageHOC';
import RouteBlock from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/RouteBlock';
import { dispatch } from 'src/store';
import { NULL } from 'src/tools/constant';
import { ChannelType } from 'src/types/common/SalesChannel';
import { ActionType } from 'src/types/common/common';
import PageWrapper from '../../../constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper2';
import RightConfigWrapper from '../../../constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import Carousel from './Carousel';
import CloneBtn from './CloneButton';
import ContentDetails from './ContentDetails';
import MiniProgramInfo from './MiniInfo';
import MiniProgramShare from './MiniShare';
import Preview from './Preview';
import ReviewKeywords from './ReviewKeywords';
import SEOSetting from './SEOSetting';
import ThumbnailImage from './ThumbnailImage';
import {
  ProductType,
  generateLongCanvas,
  generatePoster,
  generateText,
  generateVideo,
} from './common';
import { productIdHooks } from './hooks/productIdHooks';
import { convertDataFromReduxToServer } from './tools';

import {
  getCollapseOpenStatus,
  getCollapseStatus,
  getCollapseValidationMsgDisplay,
  getContent,
  getH1TagUuid,
  getHasModified,
  getLoaded,
  getModulesContent,
  getOpeningCollapse,
  getOrder,
  getProductUuid,
  getSalesChannel,
  getSalesChannelName,
  getState,
  getVisibleCollapse,
  initProductContent,
  initializeEmpty,
  moduleContentDynamicOnChange,
  moduleContentOnChange,
  moduleContentStaticOnChange,
  onCollapseOpen,
  onDuplicate,
  onErrorChange,
  onModuleTypeChange,
  submitContent,
  validation,
} from './slice';

import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from 'src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';

import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import styles from './style.module.less';

const permissions = (saleChannelUuid) => {
  const canViewDetails = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.view_product_details_page,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        uuid: saleChannelUuid,
        category: EnumCategory.SalesChannelProduct,
        subCategory: EnumSubCategory.ChannelProduct,
        operation: EnumOperation.add_edit_product,
      }),
    ],
  });
  return { canViewDetails, canCreate };
};

const SalesChannelProductContent = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const {
    onDiscard,
    submitData,
    hasModified,
    salesChannelName,
    isOnPrimaryLanguage,
  } = props;

  const order = useSelector(getOrder());
  const h1TagUuid = useSelector(getH1TagUuid());
  const loaded = useSelector(getContent('loaded'));

  const contentData = useSelector(getContent('contentDetails'));
  const productType = useSelector(getContent('productType'));
  const reviewDisplayed = useSelector(getContent('reviewDisplayed'));
  const _d = useDispatch();
  const history = useHistory();
  const type = useSalesChannelType();

  const _params: {
    salesChannelProductUuid: string;
    saleChannelUuid: string;
  } = useParams();
  const { saleChannelUuid } = _params;

  const linkSet = useSalesChannelProductLinkSet({
    salesChannelUuid: saleChannelUuid,
  });

  productIdHooks(getProductUuid);

  const onGoBack = () => {
    history.push(`/salesChannel/products/${saleChannelUuid}`);
  };

  const handleOnCollapseOpen = (idArr) => {
    _d(onCollapseOpen({ idArr }));
  };

  const handleOnModuleTypeChange = (data) => {
    _d(onModuleTypeChange(data));
  };

  const handleOnModuleOrderListChange = (obj) => {
    _d(moduleContentOnChange(obj));
  };

  const handleOnModuleContentDynamicChange = (obj) => {
    _d(moduleContentDynamicOnChange(obj));
  };

  const handleOnModuleContentStaticChange = (obj) => {
    _d(moduleContentStaticOnChange(obj));
  };
  const handleOnDuplicate = (data) => {
    _d(onDuplicate(data));
  };
  const moduleList = () => {
    return [
      {
        type: EnumModuleType.Poster,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generatePoster(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.LongCanvas,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateLongCanvas(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.Text,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateText(),
            }),
          );
        },
      },
      {
        type: EnumModuleType.Video,
        onClick: () => {
          _d(
            moduleContentOnChange({
              type: ActionType.add,
              data: generateVideo(),
            }),
          );
        },
      },
    ];
  };

  const isMulti =
    productType == ProductType.MultiplePhysical ||
    productType == ProductType.MultipleVirtual;

  const { canViewDetails, canCreate } = permissions(saleChannelUuid);
  const child =
    // !aliasUuid?
    [
      {
        body: (
          <div>
            {!isOnPrimaryLanguage && canCreate && <CloneBtn />}
            <ContentDetails
              isOnPrimaryLanguage={isOnPrimaryLanguage}
              disabled={!canCreate}
              isMulti={isMulti}
            />
            <Carousel
              isOnPrimaryLanguage={isOnPrimaryLanguage}
              disabled={!canCreate}
            />
            {(productType == ProductType.MultiplePhysical ||
              productType == ProductType.MultipleVirtual) && (
              <ThumbnailImage
                isOnPrimaryLanguage={isOnPrimaryLanguage}
                disabled={!canCreate}
              />
            )}
            {type !== ChannelType.MiniProgram && (
              <SEOSetting
                isOnPrimaryLanguage={isOnPrimaryLanguage}
                disabled={!canCreate}
              />
            )}
            {reviewDisplayed && <ReviewKeywords disabled={!canCreate} />}
            {type == ChannelType.MiniProgram && (
              <MiniProgramShare disabled={!canCreate} />
            )}
            {type == ChannelType.MiniProgram && <MiniProgramInfo />}
          </div>
        ),
        key: 'TopConfig',
      },
      {
        key: 'moduleContent',
        body: (
          <ContentGroup
            getCollapseOpenStatus={getCollapseOpenStatus}
            onCollapseOpen={handleOnCollapseOpen}
            getOpeningCollapse={getOpeningCollapse}
            getContent={getModulesContent}
            droppableId={'SalesChannelProductContent'}
            data={order}
            onModuleTypeChange={handleOnModuleTypeChange}
            onOrderListOnChange={handleOnModuleOrderListChange}
            onDynamicChange={handleOnModuleContentDynamicChange}
            onStaticChange={handleOnModuleContentStaticChange}
            linkSet={linkSet}
            getErrorDisplay={getCollapseValidationMsgDisplay}
            onErrorChange={onErrorChange}
            getVisibleCollapse={getVisibleCollapse}
            getCollapseStatus={getCollapseStatus}
            extraProps={{ h1TagUuid: h1TagUuid }}
            disabled={!canCreate}
            onDuplicate={handleOnDuplicate}
          />
        ),
      },
    ];

  return (
    <Skeleton loading={!loaded} className={styles.container}>
      <div className={styles.container}>
        <React.Fragment>
          <RouteBlock getHasModified={getHasModified} />
          <PageWrapper
            headerConfig={{
              description: canViewDetails && contentData.productName,
              topTitle: salesChannelName,
              hasModified,
              submit: canCreate && submitData,
              onDiscard,
              onGoBack,
            }}
            leftChild={
              canViewDetails ? (
                <div className={styles.left}>
                  <div className={styles.moduleCart}>
                    {loaded && canCreate && (
                      <ModuleCart moduleList={moduleList()} />
                    )}
                  </div>
                  <Preview
                    order={order}
                    getModulesContent={getModulesContent}
                    getCollapseStatus={getCollapseStatus}
                  />
                </div>
              ) : (
                <div className={styles.content}>
                  {getI18n('general.permission.permissiondenied')}
                </div>
              )
            }
            rightChild={
              loaded && canViewDetails ? (
                <RightConfigWrapper
                  title={getI18n('general.sider.content')}
                  elements={child}
                />
              ) : null
            }
          />
        </React.Fragment>
      </div>
    </Skeleton>
  );
};
export default BasicPageHOC(SalesChannelProductContent, {
  getState,
  convertDataFromReduxToServer,
  submit: submitContent,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  validation,
  getLoaded,
  queryData: (params, qParams) => {
    const { salesChannelProductUuid, saleChannelUuid } = params;
    if (salesChannelProductUuid !== NULL) {
      dispatch(
        initProductContent({
          body: salesChannelProductUuid,
          params: qParams,
        }),
      );
    } else {
      dispatch(initializeEmpty(saleChannelUuid));
    }
  },
});
